<template>
  <!--<footer class="container-fluid fixed-bottom bg-dark text-light py-2">
    <div class="row">
      <div class="col-md-12">
        <aside>&copy 2021. v{{version}}</aside>
      </div>
    </div>
  </footer>-->
</template>

<script>
export default {
  data(){
    return {
      version: VERSION
    }
  }
}
</script>
